import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { SwitchProfileComponent } from '../../dialogs/switch-profile/switch-profile.component';
import { ChangePasswordDialogComponent } from 'src/app/dialogs/change-password-dialog/change-password-dialog.component';

@Injectable({
  providedIn: 'root'
})
export class SwitchDialogService {

  constructor(private dialog: MatDialog) { }

  // Switch Profile Dialog
  openSwitchProfileDialog(userService) {
    const dialogRef = this.dialog.open(SwitchProfileComponent, {
      maxWidth: "100vw",
      width: "100vw",
      height: "100vh",
      panelClass: "switch-profile-dialog",
      autoFocus: false,
      closeOnNavigation: false,
      data: {
        userService: userService
      }
    });

    dialogRef.afterClosed().subscribe(profile => {
    });
  };

  // Open Change Password Component to change OTP password
  openChangePasswordDialog() {
    const dialogRef = this.dialog.open(ChangePasswordDialogComponent, {
      autoFocus: false,
      data: {
        isOTP: true
      },
      maxWidth: "100vw",
      width: "100vw",
      height: "100vh",
      panelClass: "profile-dialog",
      disableClose: true,
      closeOnNavigation: false
    });
    return dialogRef.afterClosed();
  }

}